export const searchFilterHandler = (searchString = '', item = '') => {
  const title = String(item?.title || '');
  return title.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
};
